// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___203Cz","m-signature-pad--body":"styles__m-signature-pad--body___2cq6c","m-signature-pad--footer":"styles__m-signature-pad--footer___1Oq62","description":"styles__description___164Go","button":"styles__button___3_LvV","clear":"styles__clear___rW2Yt","save":"styles__save___1pPDS","m-signature-pad":"styles__m-signature-pad___29Q6R","github":"styles__github___bE309","element":"styles__element___1rIbq"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/users/UserDetailsElement/styles.scss
// module id = avsK
// module chunks = client